<template>
    <dx-row :class="row.isDisabled ? 'disabled-table-checkbox' : ''" v-bind="$attrs" v-on="$listeners" :row="row"  :style="{ backgroundColor: row.isColored ? '#b3e5fc' : undefined }">
      <slot />
    </dx-row>
</template>

<script>
import { DxTable,  DxGrid, DxTableHeaderRow } from "@devexpress/dx-vue-grid-bootstrap4";

export default {
  inheritAttrs: false,
  props: ["row"],  
  components: {
    DxRow: DxTable.components.DxRow
  }
};
</script>
